export class SwipeDetector {
    constructor(win = window, doc = win.document) {
        this.win = win;
        this.doc = doc;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.windowListeners = {
            touchstart: this.onTouchStart.bind(this),
            touchend: this.onTouchEnd.bind(this)
        };
    }
    activate() {
        Object.entries(this.windowListeners)
            .forEach(([event, action]) => this.win.addEventListener(event, action));
    }
    onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
        this.touchStartY = event.changedTouches[0].screenY;
    }
    onTouchEnd(event) {
        const x = event.changedTouches[0].screenX;
        const y = event.changedTouches[0].screenY;
        const diffX = Math.abs(this.touchStartX - x);
        const diffY = Math.abs(this.touchStartY - y);
        if (diffX < 10 && diffY < 10)
            return;
        const swipeEvent = new CustomEvent('swipe', {
            detail: {
                diffX,
                diffY,
                diff: Math.max(diffX, diffY),
                swipeType: this.getSwipeType(event)
            }
        });
        this.win.dispatchEvent(swipeEvent);
    }
    getSwipeType(event) {
        const x = event.changedTouches[0].screenX;
        const y = event.changedTouches[0].screenY;
        const diffX = Math.abs(this.touchStartX - x);
        const diffY = Math.abs(this.touchStartY - y);
        if (diffX > diffY) {
            if (this.touchStartX < x) {
                return 'right';
            }
            return 'left';
        }
        if (this.touchStartY < y) {
            return 'down';
        }
        return 'up';
    }
}
